import Component from '../abstracts/Component';
import brightcovePlayerLoader from '@brightcove/player-loader';

/**
 Video brightcove
 */
export default class VideoBrightcoveComponent extends Component {

  static get SELECTORS() {
    return {
      videoWrapper: '.brightcove-wrapper',
      videoplayer: 'video-js'
    };
  }

  static getOpts (playerElement) {
    var data = $(playerElement).data();
    let isMobile = window.matchMedia('(max-width:767px)').matches;
    var opts = {
      aspectratio: isMobile & data['videoMobileId'] !== '' ? (data['aspectratioMobile'] || '16:9') : data['aspectratio'],
      playerID: data['playerId'] || 'default',
      embed: data['embed'],
      controls: data['controls'] || false,
      videoID: isMobile & data['videoMobileId'] !== '' ? data['videoMobileId'] : data['videoId'],
      autoStart: data['autostart'] || false,
      startOnScroll: data['startOnScroll'] || false,
      videoRepeat: data['repeat'] || false,
      playlistID: data['playlistId'],
      applicationID: data['applicationId'],
      muted: data['muted'] || false,
      poster: data['videoPoster'],
      hideVideo: data['hideVideo'],
      accountId: data['accountId'],
      width: data['width'] || '100%'
    };

    return opts;
  }

  static bindEvents() {

    if  ( $(VideoBrightcoveComponent.SELECTORS.videoplayer).length) {

      $(window).on('resize scroll', function (e ) {

        $(VideoBrightcoveComponent.SELECTORS.videoplayer).each(function (i, ele) {

          let videoID = $(this).attr('id'),
            opts = VideoBrightcoveComponent.getOpts($(this).parents(VideoBrightcoveComponent.SELECTORS.videoWrapper)), // container of brightcove player
            myPlayer = bc(videoID),
            currentElement = $(ele);

          if (myPlayer !== undefined) {
            if (VideoBrightcoveComponent.isElementInViewport( currentElement )) {

              if (opts.startOnScroll) {

                myPlayer.play().then(function() {
                  myPlayer.play();
                })
                  .catch(function(error) {
                    myPlayer.muted(true);
                    myPlayer.play();
                  });
              }
            }else{
              if (! myPlayer.hasClass('vjs-waiting') ){
                myPlayer.pause();
              }
            }
          }
        });
      });
    }
  }

  static initPlayer(wrapper, ele){

    let opts = VideoBrightcoveComponent.getOpts(ele),
      currentElement = $(ele),
      eleID = '#' + currentElement.attr('id'),
      videoPoster = '';

    console.log('Init: ', opts);

    if (opts.poster) {
      videoPoster = opts.poster;
    }

    brightcovePlayerLoader.reset();

    //https://support.brightcove.com/brightcove-player-loader
    // https://docs.brightcove.com/brightcove-player/1.x/Player.html

    brightcovePlayerLoader({
      refNode: document.querySelector(eleID),
      refNodeInsert: 'prepend',
      accountId: opts.accountId,  //required - A Video Cloud account ID
      playerId: opts.playerID,   //required
      videoId: opts.videoID,
      embedType: opts.embed, //in-page or iframe
      applicationId: opts.applicationID, // The application ID to be applied to the generated embed.
      media: opts.media,
      embedOptions: {
        tagName: 'video-js', // video-js or video - default is video-js
        unminified: false, // for debugging: use the un-minified version of the player
        responsive: {
          aspectRatio: opts.aspectratio,
          maxWidth : opts.width
        }
      },
      options : {
        autoplay: opts.autoStart,
        controls: opts.controls,
        loop: opts.videoRepeat,
        muted: opts.muted,
        poster: videoPoster,
      },

      onSuccess: function (success) {

        let myPlayer = success.ref,
            videoID = $(myPlayer).attr('id');
        
        if (opts.poster) {
          videoPoster = opts.poster;
        }else{
          videoPoster = myPlayer.mediainfo.poster;
        }

        myPlayer.on('error', function (error) {
          console.info('[Video Brightcove] error general', error);
        });


        myPlayer.on('loadstart', function () {
          myPlayer.poster(videoPoster);
        });

        myPlayer.on('loadedmetadata', function () {

          console.log('[Video Brightcove] loadedmetadata');

          if (!opts.controls) {
            myPlayer.controlBar.hide();
          }

          if (opts.autoStart) {
            let playVideo = myPlayer.play(); // Browser/platform autoplay policies - https://support.brightcove.com/autoplay-considerations

            if (playVideo !== undefined) { // check if the video played, otherwise I'll put the video on mute
              playVideo
                .then(function () {
                  myPlayer.muted(opts.muted);
                })
                .catch(function (error) {
                  myPlayer.muted(true);
                })
                .finally(function () {

                    console.info('autostart', opts.autoStart);

                    if (VideoBrightcoveComponent.isElementInViewport(currentElement)) {
                      myPlayer.currentTime(0);
                      myPlayer.play();
                    } else {
                      myPlayer.pause();
                    }
                });
            }
          }
        });

        myPlayer.on('loadeddata', function () {
          console.log('[Video Brightcove] loadeddata');
          VideoBrightcoveComponent.bindEvents();
        });

        myPlayer.on('ended', function () {
          if (opts.hideVideo){
            currentElement.css({
              'background-image' :'url(' + currentElement.data('videoPoster') + ')'
            });
            myPlayer.hide();
          }else{
            myPlayer.currentTime(0);
          }

          console.log('[Video Brightcove] ended player ');
          console.info('opts.poster', opts.poster);
          console.info('media', myPlayer.mediainfo.poster);
          console.info('media', myPlayer.mediainfo.thumbnail);
        });

      },

      onFailure: function (error) {
        console.info('[Video Brightocove] Loading faild', error);
      }
    });

  }

  static isElementInViewport(el) {

    var pp = $(el).offset();
    var top = pp.top;
    var left = pp.left;
    var width = el.outerWidth();
    var height = el.outerHeight(true);

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }

  setup(){
    $('.brightcove-wrapper').each(function (i) {
      let wrapper = $(this);

      if (wrapper.data('asyncSrc')) {
        window.load = VideoBrightcoveComponent.initPlayer(i, wrapper);
      }else{
        VideoBrightcoveComponent.initPlayer(i, wrapper);
      }
    });
  }

  init() {
    // BrightCove: https://github.com/brightcove/player-loader
    this.setup();
  }

  render() {
    this.log('Rendering...');
    super.render();
    this.init();
  }
}
